// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  helperText?: string;
  variant?: TextFieldProps['variant'];
};

export default function RHFTextField({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          variant={other.variant || 'outlined'}
          fullWidth
          value={field.value ?? ''}
          error={!!error}
          helperText={error?.message || helperText || ''}
          {...other}
        />
      )}
    />
  );
}
